import api from './api'

const ContractorService = {
    // Add a new contractor
    addContractor(payload) {
        return api.put('/contractor/add_contractor', payload);
    },

    // Get all contractors
    getAllContractors() {
        return api.get('/contractor/get_all_contractors');
    },

    // Get all contractors for a specific factory
    getAllFactoryContractors(factory_id) {
        return api.get(`/contractor/get_all_factory_contractors/${factory_id}`);
    },

    // Get a specific contractor by ID
    getContractor(id) {
        return api.get(`/contractor/get_contractor/${id}`);
    },

    // Toggle contractor status (active/inactive)
    toggleContractorStatus(id) {
        return api.put(`/contractor/toggle_contractor_status/${id}`);
    },

    // Update contractor details
    updateContractor(payload) {
        return api.put('/contractor/update_contractor', payload);
    },
    deleteContractor(id){
        return api.delete(`/contractor/delete_contractor/${id}`)
    }
}

export default ContractorService;